import ApiModule from './index'
import BaseModel from '../../base/BaseModel'

export class GetFastSecurityCheckById extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.PRODUCT
		this.url = '/queryFastSecurityCheck/getFastSecurityCheckById'
		this.desc = '根据ID获取安检详情'
	}
}

export class QueryFastSecurityCheckDateList extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.PRODUCT
		this.url = '/queryFastSecurityCheck/queryFastSecurityCheckDateList'
		this.desc = '根据产品ID获取可使用的日期列表和不可用原因'
	}
}

export class GetProductSalePriceDetail extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.PRODUCT
		this.url = '/productSalePrice/getProductSalePriceDetail'
		this.desc = '根据产品id获取产品价格详情列表'
	}
}
